export default {
  name: "login-index",

  data() {
    return {
      state: "phone",
      errMsg: false,
      errorMessage: ""
    };
  },

  created() {
    //clear local storage 'form'
    localStorage.removeItem("form");
  },

  watch: {
    state() {
      this.showErrorMessage(false);
    }

  },
  methods: {
    showErrorMessage(msg) {
      if (msg === false) {
        this.errMsg = false;
        this.errorMessage = "";
        return;
      }

      this.errMsg = true;
      this.errorMessage = msg;
    }

  }
};